import React from 'react';
import {
  Filter as FilterAdmin,
  TextInput,
  SelectInput,
  BooleanInput,
} from 'react-admin';

import { STATUS_ATIVO, STATUS_INATIVO } from '../../utils';

const choices = [
  { id: STATUS_ATIVO, name: 'Ativo' },
  { id: STATUS_INATIVO, name: 'Inativo' },
];

const Filter = (props) => (
  <FilterAdmin {...props}>
    <TextInput label="Descrição" source="descricao" />
    <SelectInput
      source="status"
      choices={choices}
      label="Status"
      allowEmpty={false}
    />
    <BooleanInput label="ind_gTribRegular" source="ind_gTribRegular" />
    <BooleanInput label="ind_gCredPresOper" source="ind_gCredPresOper" />
    <BooleanInput label="ind_gMonoPadrao" source="ind_gMonoPadrao" />
    <BooleanInput label="ind_gMonoReten" source="ind_gMonoReten" />
    <BooleanInput label="ind_gMonoRet" source="ind_gMonoRet" />
    <BooleanInput label="ind_gMonoDif" source="ind_gMonoDif" />
    <BooleanInput label="ind_gEstornoCred" source="ind_gEstornoCred" />
    <BooleanInput label="indNFe" source="indNFe" />
    <BooleanInput label="indNFCe" source="indNFCe" />
  </FilterAdmin>
);

export default Filter;
